import { FlightResultsState } from '@flight-results/store/reducers/flight-results.reducer';
import { SelectedFlightsState } from '@flight-results/store/reducers/selected-flights.reducer';
import {
  FlightAmenitieResultItem,
  FlightResultsMobileBySector,
  NewAirResultsResponse
} from '@app/entities/flight-results';
import { NewAirSearchPayload } from '@flight-results/entities/request-search.payload';
import { SearchResultsData } from '@flight-results/entities/search-results-data';
import { FlightWidgetsMobile } from '@app/entities/flight-results-widget';
import { FlexibleDatesResult, FlexibleDatesMappedResult } from '@flight-results/entities/flexible.dates';
import { FlightCabin, FlightDetailCabinPayload } from '@shared/flight-itinerary/entities/cabin-types';
import { ShowedDetailsFlightsState } from '@flight-results/store/reducers/ui/showed-details.reducer';

export const flightResultsFeatureName = 'flightResultsModuleState';

export type UiFlightsState = Readonly<{
  isLoadingFilters: boolean,
  itinerarySelected: string,
  isLoadingFlexDates: boolean,
  isLoadingExchange: boolean,
  isclearFlights: boolean,
  isLoadingFlightsScroll: boolean,
  disabledFlightScroll: boolean,
  isLoadingFlightCabin: boolean,
  isLoadingFlightCabinDetail: boolean,
  showedDetails: ShowedDetailsFlightsState,
  errorInExchangeBook: boolean,
  successExchange: boolean,
  isLoadingExchangePush: boolean,
}>;

export type FlightResultsModuleState = Readonly<{
  flightResults: FlightResultsState,
  selectedFlights: SelectedFlightsState,
  flightResultsDesktop: NewAirResultsResponse,
  searchPayload: NewAirSearchPayload,
  searchResultsData: SearchResultsData,
  flightResultsMobile: NewAirResultsResponse,
  flightResultsMobileBySector: FlightResultsMobileBySector[],
  ui: UiFlightsState,
  flightResultsWidgets: FlightWidgetsMobile,
  flexDates: FlexibleDatesResult,
  flexDatesMapped: FlexibleDatesMappedResult,
  flightCabinSelected: FlightCabin,
  flightCabinPayload: FlightDetailCabinPayload,
  flightCabinDetailSelected: FlightAmenitieResultItem[]
}>;
